(function () {
  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getFieldValue(value) {
    if (value && typeof value === 'object' && Object.prototype.hasOwnProperty.call(value, 'value')) {
      return value.value;
    }
    return value;
  }

  function normalizeFeaturedReview(review) {
    return {
      id: getFieldValue(review.id) || '',
      handle: getFieldValue(review.handle) || '',
      review_title: getFieldValue(review.review_title) || '',
      review_desc: getFieldValue(review.review_desc) || '',
      user_name: getFieldValue(review.user_name) || 'Anonymous',
      posted_date: getFieldValue(review.posted_date) || '',
      rating: parseInt(getFieldValue(review.rating) || 0, 10) || 0,
      review_img: getFieldValue(review.review_img) || '',
      video_url: getFieldValue(review.video_url) || '',
      status: String(getFieldValue(review.status) || 'true'),
      verified_badge: String(getFieldValue(review.verified_badge) || 'false'),
      unix_time: getFieldValue(review.unix_time) || '',
      product_handle: getFieldValue(review.product_handle) || '',
      product_title: getFieldValue(review.product_title) || '',
      product_image_url: getFieldValue(review.product_image_url) || '',
      product_image_alt: getFieldValue(review.product_image_alt) || ''
    };
  }

  function normalizeFetchedReview(node) {
    var productReference = node && node.product_node && node.product_node.reference ? node.product_node.reference : null;

    return {
      id: node && node.id ? String(node.id) : '',
      handle: node && node.handle ? String(node.handle) : '',
      review_title: getFieldValue(node && node.review_title) || '',
      review_desc: getFieldValue(node && node.review_desc) || '',
      user_name: getFieldValue(node && node.user_name) || 'Anonymous',
      posted_date: getFieldValue(node && node.posted_date) || '',
      rating: parseInt(getFieldValue(node && node.rating) || 0, 10) || 0,
      review_img: getFieldValue(node && node.review_img) || '',
      video_url: getFieldValue(node && node.video_url) || '',
      status: String(getFieldValue(node && node.status) || 'true'),
      verified_badge: String(getFieldValue(node && node.verified_badge) || 'false'),
      unix_time: getFieldValue(node && node.unix_time) || '',
      product_handle: productReference && productReference.handle ? String(productReference.handle) : '',
      product_title: productReference && productReference.title ? String(productReference.title) : '',
      product_image_url: productReference && productReference.featuredImage && productReference.featuredImage.url ? String(productReference.featuredImage.url) : '',
      product_image_alt: productReference && productReference.featuredImage && productReference.featuredImage.altText ? String(productReference.featuredImage.altText) : ''
    };
  }

  function renderStars(value) {
    var rating = Math.max(0, Math.min(5, parseInt(value || 0, 10)));
    var html = '';
    var index;

    for (index = 1; index <= 5; index += 1) {
      html += '<span class="star"><svg style="color:' + (index <= rating ? '#FFA800' : 'rgba(0,0,0,.2)') + '" class="loox-icon" viewBox="0 0 24 24" data-lx-fill="full" aria-hidden="true"><use href="#trustoo-rating-icon"></use></svg></span>';
    }

    return html;
  }

  function getReviewKey(review) {
    if (review.id) return 'id:' + review.id;
    if (review.handle) return 'handle:' + review.handle;

    return getReviewFingerprint(review);
  }

  function getReviewFingerprint(review) {
    if (!review) return '';

    return [
      review.user_name || '',
      review.review_desc || '',
      review.rating || '',
      review.product_handle || ''
    ].join('|');
  }

  function getReviewRatingFromElement(element) {
    var stars = element ? element.querySelectorAll('.star svg') : [];
    var count = 0;

    Array.prototype.forEach.call(stars, function (star) {
      var parent = star.closest ? star.closest('svg') : star.parentNode;
      var style = parent && parent.getAttribute ? String(parent.getAttribute('style') || '') : '';
      var color = parent && parent.style ? String(parent.style.color || '') : '';
      if (style.indexOf('#FFA800') !== -1 || color.indexOf('255, 168, 0') !== -1 || color.indexOf('#ffa800') !== -1 || color.indexOf('rgb(255, 168, 0)') !== -1) {
        count += 1;
      }
    });

    return count;
  }

  function getReviewFingerprintFromElement(element) {
    var explicitFingerprint;
    var userName;
    var reviewDesc;
    var rating;
    var productLink;
    var productHref;
    var productHandle = '';

    if (!element) return '';

    explicitFingerprint = element.getAttribute('data-grt-review-fingerprint') || '';
    if (explicitFingerprint) return explicitFingerprint;

    userName = (element.querySelector('.user-name') || {}).textContent || '';
    reviewDesc = (element.querySelector('.review-content') || {}).textContent || '';
    rating = getReviewRatingFromElement(element);
    productLink = element.querySelector('.product-link');
    productHref = productLink && productLink.getAttribute ? productLink.getAttribute('href') : '';

    userName = String(userName).trim();
    reviewDesc = String(reviewDesc).trim();
    productHref = String(productHref).trim();
    if (productHref.indexOf('/products/') !== -1) {
      productHandle = productHref.split('/products/')[1].split('?')[0].split('#')[0];
    }

    if (!userName && !reviewDesc) return '';

    return [userName, reviewDesc, rating, productHandle].join('|');
  }

  function getReviewKeyFromElement(element) {
    if (!element) return '';
    return element.getAttribute('data-grt-review-key') || element.getAttribute('data-review-key') || '';
  }

  function collectRenderedReviewIdentity(scope) {
    var keys = new Set();
    var fingerprints = new Set();
    var cards;

    if (!scope || !scope.querySelectorAll) {
      return { keys: keys, fingerprints: fingerprints };
    }

    cards = scope.querySelectorAll('.review-item');
    Array.prototype.forEach.call(cards, function (card) {
      var key = getReviewKeyFromElement(card);
      var fingerprint = getReviewFingerprintFromElement(card);

      if (key) keys.add(key);
      if (fingerprint) fingerprints.add(fingerprint);
    });

    return { keys: keys, fingerprints: fingerprints };
  }

  function parseBucketIds(raw) {
    if (!raw) return [];
    if (Array.isArray(raw)) return raw.map(String).filter(Boolean);

    try {
      var parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
      return Array.isArray(parsed) ? parsed.map(String).filter(Boolean) : [];
    } catch (error) {
      return [];
    }
  }

  function getReviewImageUrl(rawValue, width) {
    var value = rawValue;
    var first = '';

    if (!value) return '';

    if (Array.isArray(value)) {
      first = value[0] || '';
    } else if (value && typeof value === 'object') {
      first = value.url || value.src || '';
    } else {
      try {
        var parsed = JSON.parse(String(value).replace(/\\"/g, '"'));
        if (Array.isArray(parsed)) first = parsed[0] || '';
      } catch (error) {
        first = String(value);
      }
    }

    if (!first) return '';

    var normalized = String(first).trim().replace('/review_app/uploads/reviews/', '/review_app/img/get/');
    return width ? normalized + '?w=' + width : normalized;
  }

  function renderImageHtml(rawValue, largeImage) {
    var imageUrl = getReviewImageUrl(rawValue, largeImage ? 800 : 300);
    var width = largeImage ? 800 : 300;
    var height = Math.round(width * 3 / 4);

    if (!imageUrl) return '';

    return '' +
      '<div class="review-image-container" style="aspect-ratio:4 / 3" data-default-ratio="4 / 3">' +
        '<img src="' + escapeHtml(imageUrl) + '" class="review-image" loading="lazy" decoding="async" width="' + width + '" height="' + height + '" alt="">' +
      '</div>';
  }

  function withWidthParam(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function getYouTubeVideoId(value) {
    var url = String(value || '').trim();
    var match;

    if (!url) return { id: '', isShort: false };

    if (/youtube\.com\/shorts\//i.test(url)) {
      return {
        id: url.split('/shorts/')[1].split(/[?&]/)[0] || '',
        isShort: true
      };
    }

    match = url.match(/youtu\.be\/([^?&]+)/i) || url.match(/[?&]v=([^?&]+)/i) || url.match(/embed\/([^?&]+)/i);

    return {
      id: match && match[1] ? match[1] : '',
      isShort: false
    };
  }

  function renderVideoThumb(rawValue) {
    var parsed = getYouTubeVideoId(rawValue);
    var poster;

    if (!parsed.id) return '';

    poster = 'https://i.ytimg.com/vi/' + parsed.id + '/hqdefault.jpg';

    return '' +
      '<div class="review-video-container' + (parsed.isShort ? ' is-short' : '') + '">' +
        '<button type="button" class="review-video-thumb js-grt-yt-thumb" data-ytid="' + escapeHtml(parsed.id) + '" aria-label="Play video">' +
          '<img src="' + escapeHtml(poster) + '" alt="" loading="lazy" decoding="async">' +
          '<span class="review-video-play" aria-hidden="true"></span>' +
        '</button>' +
      '</div>';
  }

  function buildProductUrl(config, review, medium) {
    if (!review.product_handle || !config.shopUrl) return '';
    return config.shopUrl + '/products/' + review.product_handle + '?utm_source=reviewapp&utm_medium=' + (medium || 'productreviewcta') + '&utm_campaign=grt-social';
  }

  function ensureDetailModal() {
    var existing = document.getElementById('grt_review_modal');

    if (existing) return existing;

    existing = document.createElement('div');
    existing.id = 'grt_review_modal';
    existing.className = 'grt_review_modal';
    existing.setAttribute('aria-hidden', 'true');
    existing.innerHTML = '' +
      '<div class="grt_review_modal__overlay" data-grt-review-close></div>' +
      '<div class="grt_review_modal__dialog">' +
        '<button class="grt_review_modal__close" data-grt-review-close>&times;</button>' +
        '<div class="grt_review_modal__content">' +
          '<div class="grt_review_modal__media js-grt-review-media"></div>' +
          '<div class="grt_review_modal__details">' +
            '<div class="grt_review_modal__rating js-grt-review-rating"></div>' +
            '<div class="grt_review_modal__meta">' +
              '<span class="js-grt-review-name"></span>' +
              '<span style="display:none;" class="js-grt-review-date"></span>' +
            '</div>' +
            '<p class="grt_review_modal__text js-grt-review-text"></p>' +
            '<div class="grt_review_modal__product js-grt-review-product"></div>' +
          '</div>' +
        '</div>' +
      '</div>';

    document.body.appendChild(existing);

    existing.addEventListener('click', function (event) {
      if (event.target.matches('[data-grt-review-close]') || event.target.classList.contains('grt_review_modal__overlay')) {
        existing.classList.remove('grt_is_visible');
        existing.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('grt_review_modal_open');
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        existing.classList.remove('grt_is_visible');
        existing.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('grt_review_modal_open');
      }
    });

    return existing;
  }

  function openDetailModal(config, review) {
    var modal = ensureDetailModal();
    var mediaEl = modal.querySelector('.js-grt-review-media');
    var ratingEl = modal.querySelector('.js-grt-review-rating');
    var nameEl = modal.querySelector('.js-grt-review-name');
    var dateEl = modal.querySelector('.js-grt-review-date');
    var textEl = modal.querySelector('.js-grt-review-text');
    var productEl = modal.querySelector('.js-grt-review-product');
    var dateValue = review.posted_date ? new Date(review.posted_date).toLocaleDateString('en-GB', { day: 'numeric', month: 'numeric', year: 'numeric' }) : '';
    var videoHtml = renderVideoThumb(review.video_url);
    var imageHtml = renderImageHtml(review.review_img, true);
    var productUrl = buildProductUrl(config, review, 'productreviewcta');

    mediaEl.innerHTML = videoHtml || imageHtml || '';
    ratingEl.innerHTML = renderStars(review.rating);
    nameEl.textContent = review.user_name || 'Anonymous';
    dateEl.textContent = dateValue;
    textEl.textContent = review.review_desc || '';
    productEl.innerHTML = productUrl ? '<div class="grt_review_modal__product-inner"><a href="' + escapeHtml(productUrl) + '" target="_blank" class="grt_review_modal__cta">View product</a></div>' : '';

    modal.classList.add('grt_is_visible');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('grt_review_modal_open');
  }

  function renderCard(config, review, index) {
    var mediaHtml = renderVideoThumb(review.video_url) || renderImageHtml(review.review_img, false);
    var isVerified = String(review.verified_badge || '').toLowerCase() === 'true';
    var productUrl = buildProductUrl(config, review, 'productreview_link');
    var productHtml = '';
    var reviewKey = getReviewKey(review);
    var reviewFingerprint = getReviewFingerprint(review);

    if (config.mode === 'home' && review.product_handle) {
      productHtml = '' +
        '<div class="review-small review_type_home">' +
          '<a href="' + escapeHtml(productUrl) + '" target="_blank" rel="noopener" class="product-link">' +
            (review.product_image_url ? '<span><img src="' + escapeHtml(withWidthParam(review.product_image_url, 40)) + '" alt="' + escapeHtml(review.product_image_alt || '') + '" loading="lazy"></span>' : '') +
            escapeHtml(review.product_title || '') +
          '</a>' +
        '</div>';
    }

    return '' +
      '<div class="review-item" data-grt-review-index="' + index + '" data-grt-review-key="' + escapeHtml(reviewKey) + '" data-grt-review-fingerprint="' + escapeHtml(reviewFingerprint) + '">' +
        '<div class="review-item-wrap">' +
          mediaHtml +
          '<div class="review-details">' +
            '<div class="review-header">' +
              '<div class="star-rating">' + renderStars(review.rating) + '</div>' +
              '<p class="review-date"></p>' +
            '</div>' +
            (isVerified ? '<div class="user-verified"><svg class="trustoo-badge-icon" width="14" height="14" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="#333" fill-rule="evenodd" clip-rule="evenodd" d="M7.19673 0.0153323L12.5436 0.837143C13.1763 0.935269 13.6434 1.47905 13.6434 2.11994V10.5895C13.6434 10.9922 13.4564 11.3725 13.1375 11.6178L7.7906 15.7309C7.56377 15.9054 7.28562 16 6.99945 16C6.71328 16 6.43514 15.9054 6.20831 15.7309L0.861434 11.6178C0.542522 11.3725 0.355469 10.9922 0.355469 10.5895V2.11994C0.355469 1.47905 0.822592 0.935269 1.4553 0.837143L6.80218 0.0153323C6.93301 -0.00511076 7.06589 -0.00511076 7.19673 0.0153323ZM5.51506 10.4871C5.64668 10.6197 5.81854 10.6863 5.99108 10.6863C6.16294 10.6863 6.33549 10.6197 6.46711 10.4871L11.1796 5.72205C11.4422 5.4563 11.4422 5.02573 11.1796 4.75997C10.9164 4.49353 10.4902 4.49353 10.2276 4.75997L5.99108 9.04298L3.77394 6.80156C3.51138 6.5358 3.08514 6.5358 2.82189 6.80156C2.55932 7.06732 2.55932 7.49857 2.82189 7.76433L5.51506 10.4871Z"></path></svg><span class="verified-text">Verified purchase</span></div>' : '') +
            '<div class="reviewer-name"><span class="user-name">' + escapeHtml(review.user_name || 'Anonymous') + '</span><span class="country-flag IN" style="border:1px solid #ccc"></span></div>' +
            '<p class="review-content">' + escapeHtml(review.review_desc || '') + '</p>' +
          '</div>' +
          productHtml +
        '</div>' +
      '</div>';
  }

  function htmlToElements(html) {
    var template = document.createElement('template');
    template.innerHTML = html.trim();
    return Array.prototype.slice.call(template.content.querySelectorAll('.review-item'));
  }

  function injectLayoutStyles(config) {
    var styleId = 'reviews-isotope-styles-' + config.sectionId;
    var style = document.getElementById(styleId);
    var widthDesktop = (100 / Math.max(1, config.deskCols)).toFixed(5) + '%';

    if (style) return;

    style = document.createElement('style');
    style.id = styleId;
    style.textContent = '' +
      '#reviews-container-' + config.sectionId + '{position:relative}' +
      '#reviews-container-' + config.sectionId + ' .grid-sizer,#reviews-container-' + config.sectionId + ' .review-item{width:' + widthDesktop + '}' +
      '@media (max-width:1024px){#reviews-container-' + config.sectionId + ' .grid-sizer,#reviews-container-' + config.sectionId + ' .review-item{width:33.3333%}}' +
      '@media (max-width:640px){#reviews-container-' + config.sectionId + ' .grid-sizer,#reviews-container-' + config.sectionId + ' .review-item{width:50%}}' +
      '#reviews-container-' + config.sectionId + ' .review-item{margin-bottom:16px;box-sizing:border-box}' +
      '#reviews-container-' + config.sectionId + ' .review-image{width:100%;height:auto;display:block}';

    document.head.appendChild(style);
  }

  function getPagedReviewIds(config, cursor) {
    var bucketIndex = cursor && Number.isInteger(cursor.bucketIndex) ? cursor.bucketIndex : 0;
    var bucketOffset = cursor && Number.isInteger(cursor.bucketOffset) ? cursor.bucketOffset : 0;
    var ids = [];

    while (bucketIndex < config.reviewMetaBuckets.length && ids.length < config.pageSize) {
      var bucketIds = parseBucketIds(config.reviewMetaBuckets[bucketIndex]);

      if (bucketOffset >= bucketIds.length) {
        bucketIndex += 1;
        bucketOffset = 0;
        continue;
      }

      var remaining = config.pageSize - ids.length;
      var slice = bucketIds.slice(bucketOffset, bucketOffset + remaining);
      ids = ids.concat(slice);
      bucketOffset += slice.length;

      if (bucketOffset >= bucketIds.length) {
        bucketIndex += 1;
        bucketOffset = 0;
      }
    }

    var hasNext = false;
    var nextCursor = null;
    var index;

    for (index = bucketIndex; index < config.reviewMetaBuckets.length; index += 1) {
      var idsInBucket = parseBucketIds(config.reviewMetaBuckets[index]);
      var offset = index === bucketIndex ? bucketOffset : 0;

      if (offset < idsInBucket.length) {
        hasNext = true;
        nextCursor = { bucketIndex: index, bucketOffset: offset };
        break;
      }
    }

    return { ids: ids, hasNext: hasNext, nextCursor: nextCursor };
  }

  async function fetchReviewsByIds(config, ids) {
    var query;
    var response;
    var json;
    var nodes;

    if (!config.storefrontToken || !config.shopifyDomain || !ids.length) return [];

    query = '\n      query GetReviewsByIds($ids: [ID!]!) {\n        nodes(ids: $ids) {\n          ... on Metaobject {\n            id\n            handle\n            type\n            review_title: field(key: "review_title") { value }\n            review_desc: field(key: "review_desc") { value }\n            user_name: field(key: "user_name") { value }\n            posted_date: field(key: "posted_date") { value }\n            rating: field(key: "rating") { value }\n            review_img: field(key: "review_img") { value }\n            video_url: field(key: "video_url") { value }\n            status: field(key: "status") { value }\n            is_featured: field(key: "is_featured") { value }\n            verified_badge: field(key: "verified_badge") { value }\n            unix_time: field(key: "unix_time") { value }\n            product_node: field(key: "product_node") {\n              value\n              reference {\n                ... on Product {\n                  id\n                  handle\n                  title\n                  featuredImage {\n                    url\n                    altText\n                    width\n                    height\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    ';

    try {
      response = await fetch('https://' + config.shopifyDomain + '/api/2025-01/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': config.storefrontToken
        },
        body: JSON.stringify({ query: query, variables: { ids: ids } })
      });
      json = await response.json().catch(function () { return {}; });
    } catch (error) {
      console.error('Review fetch failed for section ' + config.sectionId, error);
      return [];
    }

    if (!response.ok || !json || json.errors) {
      console.error('GraphQL review fetch error for section ' + config.sectionId, json && json.errors ? json.errors : response.status);
      return [];
    }

    nodes = (json.data && json.data.nodes ? json.data.nodes : []).filter(Boolean).map(normalizeFetchedReview);
    return nodes.filter(function (review) {
      return String(review.status || '').toLowerCase() !== 'false';
    });
  }

  function filterUniqueReviews(reviews, seenKeys, seenFingerprints) {
    return reviews.filter(function (review) {
      var key = getReviewKey(review);
      var fingerprint = getReviewFingerprint(review);
      if (seenKeys.has(key)) return false;
      if (fingerprint && seenFingerprints && seenFingerprints.has(fingerprint)) return false;
      seenKeys.add(key);
      if (fingerprint && seenFingerprints) seenFingerprints.add(fingerprint);
      return true;
    });
  }

  function getScopedFeaturedReviews(config) {
    var reviews = (config.featuredReviews || []).map(normalizeFeaturedReview).filter(function (review) {
      return String(review.status || '').toLowerCase() !== 'false';
    });
    var exactMatches;
    var genericTrustReviews;
    var otherTrustReviews;

    if (config.mode !== 'product' || !config.productHandle) return reviews;

    exactMatches = reviews.filter(function (review) {
      return review.product_handle === config.productHandle;
    });

    genericTrustReviews = reviews.filter(function (review) {
      return !review.product_handle;
    });

    otherTrustReviews = reviews.filter(function (review) {
      return review.product_handle && review.product_handle !== config.productHandle;
    });

    return exactMatches.concat(genericTrustReviews, otherTrustReviews);
  }

  function hasBucketReviewIds(config) {
    return (config.reviewMetaBuckets || []).some(function (bucket) {
      return parseBucketIds(bucket).length > 0;
    });
  }

  function renderNoReviewState(container, config) {
    container.innerHTML = '' +
      '<div class="grt-no-review-block">' +
        '<div><button class="btn grt-btn-cta-box" onclick="openReview()">Write a Review</button></div>' +
        '<div class="grt-noreview-ratting-wrapper"><div class="star-rating">' + renderStars(0) + '</div><p>There are no reviews yet.</p></div>' +
      '</div>';
  }

  function mountIsotope(container) {
    var iso;

    if (!window.Isotope) return null;

    iso = new window.Isotope(container, {
      itemSelector: '.review-item',
      layoutMode: 'masonry',
      percentPosition: true,
      masonry: { columnWidth: '.grid-sizer', gutter: 0 }
    });

    iso.on('layoutComplete', function () {
      syncContainerHeight(iso);
    });

    return iso;
  }

  function syncContainerHeight(iso) {
    var container;
    var items;
    var maxBottom = 0;

    if (!iso || !iso.element) return;

    container = iso.element;
    items = iso.filteredItems && iso.filteredItems.length ? iso.filteredItems : iso.items || [];

    if (!items.length) {
      container.style.height = 'auto';
      return;
    }

    Array.prototype.forEach.call(items, function (item) {
      var element = item && item.element ? item.element : item;
      var positionY = item && item.position && typeof item.position.y === 'number' ? item.position.y : 0;
      var itemHeight = item && item.size && typeof item.size.outerHeight === 'number' ? item.size.outerHeight : 0;
      var bottom;

      if (!element || element.classList.contains('grid-sizer')) return;
      if (!itemHeight) itemHeight = element.offsetHeight || 0;

      bottom = positionY + itemHeight;
      if (bottom > maxBottom) maxBottom = bottom;
    });

    container.style.height = Math.ceil(maxBottom) + 'px';
  }

  function requestLayout(iso) {
    if (!iso) return;
    window.requestAnimationFrame(function () {
      iso.layout();
      window.requestAnimationFrame(function () {
        syncContainerHeight(iso);
      });
    });
  }

  function syncImageContainerRatio(img) {
    var wrap;
    var width;
    var height;

    if (!img) return;

    wrap = img.closest('.review-image-container');
    if (!wrap) return;

    width = img.naturalWidth || 0;
    height = img.naturalHeight || 0;

    if (!width || !height) {
      wrap.style.aspectRatio = wrap.getAttribute('data-default-ratio') || '4 / 3';
      return;
    }

    wrap.style.aspectRatio = width + ' / ' + height;
  }

  function bindRelayout(iso, scope) {
    var images = scope.querySelectorAll('img');

    Array.prototype.forEach.call(images, function (img) {
      if (img.complete) {
        syncImageContainerRatio(img);
        requestLayout(iso);
        return;
      }

      img.addEventListener('load', function () {
        syncImageContainerRatio(img);
        requestLayout(iso);
      }, { once: true });
      img.addEventListener('error', function () {
        syncImageContainerRatio(img);
        requestLayout(iso);
      }, { once: true });
    });
  }

  async function waitForIsotope() {
    return new Promise(function (resolve) {
      var startedAt = Date.now();
      var timer;

      if (window.Isotope) {
        resolve(true);
        return;
      }

      timer = window.setInterval(function () {
        if (window.Isotope) {
          window.clearInterval(timer);
          resolve(true);
          return;
        }

        if (Date.now() - startedAt >= 5000) {
          window.clearInterval(timer);
          resolve(false);
        }
      }, 50);
    });
  }

  function parseConfig(root) {
    var sectionId = root.getAttribute('data-grt-reviews');
    var script = document.querySelector('[data-grt-reviews-config-for="' + sectionId + '"]');

    if (!script) return null;

    try {
      return JSON.parse(script.textContent || '{}');
    } catch (error) {
      console.error('Invalid GRT review config for section ' + sectionId, error);
      return null;
    }
  }

  function getReviewRootKey(config) {
    if (!config) return null;
    if (config.mode === 'product' && config.productHandle) return 'product:' + config.productHandle;
    return 'section:' + config.sectionId;
  }

  function bindModalWidget(config) {
    if (!config.isModal) return;

    var modal = document.getElementById('review-modal-' + config.sectionId);
    var opener = document.getElementById('open-review-modal-' + config.sectionId);
    var closer;

    if (!modal || !opener) return;

    closer = modal.querySelector('[data-close]');
    opener.onclick = function () { modal.style.display = 'block'; };
    if (closer) closer.onclick = function () { modal.style.display = 'none'; };
    modal.onclick = function (event) {
      if (event.target === modal) modal.style.display = 'none';
    };
  }

  function attachSectionEvents(root, config, state) {
    root.addEventListener('click', function (event) {
      var thumb = event.target.closest('.js-grt-yt-thumb');
      var card;
      var index;
      var review;
      var container;

      if (thumb) {
        event.preventDefault();
        event.stopPropagation();
        container = thumb.closest('.review-video-container');
        if (!container) return;

        container.innerHTML = '' +
          '<iframe src="https://www.youtube.com/embed/' + escapeHtml(thumb.getAttribute('data-ytid') || '') + '?autoplay=1&rel=0&modestbranding=1&playsinline=1&mute=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
        requestLayout(state.iso);
        return;
      }

      card = event.target.closest('#reviews-container-' + config.sectionId + ' [data-grt-review-index]');
      if (!card) return;

      index = Number(card.getAttribute('data-grt-review-index'));
      review = state.reviews[index];

      if (review) openDetailModal(config, review);
    });
  }

  function appendReviews(container, config, state, reviews) {
    var startIndex = state.reviews.length;
    var html = '';
    var elements;

    reviews.forEach(function (review, offset) {
      state.reviews[startIndex + offset] = review;
      html += renderCard(config, review, startIndex + offset);
    });

    elements = htmlToElements(html);
    elements.forEach(function (element) {
      container.appendChild(element);
    });

    if (state.iso && elements.length) {
      state.iso.appended(elements);
      requestLayout(state.iso);
    }

    bindRelayout(state.iso, container);
  }

  async function getNextBatch(config, state, desiredCount) {
    var targetCount = typeof desiredCount === 'number' ? desiredCount : config.pageSize;
    var collected = [];
    var seenKeys = new Set(state.renderedKeys);
    var seenFingerprints = new Set(state.renderedFingerprints);
    var page;
    var fetchedReviews;

    while (collected.length < targetCount && !state.productReviewsExhausted) {
      page = getPagedReviewIds(config, state.nextCursor);
      state.nextCursor = page.nextCursor;
      state.productReviewsExhausted = !page.hasNext;

      if (!page.ids.length) break;

      fetchedReviews = await fetchReviewsByIds(config, page.ids);
      collected = collected.concat(filterUniqueReviews(fetchedReviews, seenKeys, seenFingerprints));

      if (!page.hasNext) break;
    }

    while (collected.length < targetCount && state.featuredOffset < state.featuredReviews.length) {
      var featuredReview = state.featuredReviews[state.featuredOffset];
      var featuredKey = getReviewKey(featuredReview);
      var featuredFingerprint = getReviewFingerprint(featuredReview);
      state.featuredOffset += 1;

      if (seenKeys.has(featuredKey)) continue;
      if (featuredFingerprint && seenFingerprints.has(featuredFingerprint)) continue;
      seenKeys.add(featuredKey);
      if (featuredFingerprint) seenFingerprints.add(featuredFingerprint);
      collected.push(featuredReview);
    }

    return {
      reviews: collected,
      hasNext: !state.productReviewsExhausted || state.featuredOffset < state.featuredReviews.length
    };
  }

  function updateLoadMore(config, state) {
    var button = document.getElementById('load-more-' + config.sectionId);

    if (!button) return;
    button.hidden = !state.hasNext;
    button.style.display = state.hasNext ? '' : 'none';
  }

  function bindLoadMore(container, root, config, state) {
    var button = document.getElementById('load-more-' + config.sectionId);

    if (!button || button.dataset.grtBound === 'true') return;
    button.dataset.grtBound = 'true';

    button.addEventListener('click', async function () {
      var previousLabel = button.textContent;
      var result;

      if (state.loading || !state.hasNext) return;

      state.loading = true;
      button.textContent = 'Loading...';
      button.disabled = true;

      try {
        result = await getNextBatch(config, state);
        if (result.reviews.length) {
          result.reviews.forEach(function (review) {
            state.renderedKeys.add(getReviewKey(review));
            state.renderedFingerprints.add(getReviewFingerprint(review));
          });
          appendReviews(container, config, state, result.reviews);
        }
        state.hasNext = result.hasNext;
        updateLoadMore(config, state);
      } catch (error) {
        console.error('Load more failed for review section ' + config.sectionId, error);
      } finally {
        button.textContent = previousLabel;
        button.disabled = false;
        state.loading = false;
      }
    });
  }

  async function initSection(root) {
    var config = parseConfig(root);
    var container;
    var gridSizer;
    var state;
    var result;
    var missingCount;
    var existingPageReviewIdentity;
    var existingContainerReviewCount;
    var totalVisibleReviews;

    if (!config) return;

    config.pageSize = Math.min(config.initialLimit || 16, 20);
    config.deskCols = config.deskCols || 4;
    config.reviewMetaBuckets = config.reviewMetaBuckets || [];
    config.featuredReviews = config.featuredReviews || [];
    config.storefrontToken = config.storefrontToken || '85c79415090567d4cb4d6d1ffe67746d';
    config.shopifyDomain = config.shopifyDomain || (window.Shopify && window.Shopify.shop) || '';
    config.shopUrl = config.shopUrl || '';

    bindModalWidget(config);

    container = document.getElementById('reviews-container-' + config.sectionId);
    if (!container) return;

    injectLayoutStyles(config);
    existingPageReviewIdentity = collectRenderedReviewIdentity(document);
    existingContainerReviewCount = container.querySelectorAll('.review-item').length;

    if (!existingContainerReviewCount) {
      container.innerHTML = '<p id="reviews-loading-' + config.sectionId + '" style="text-align:center;margin:20px 0;">Loading reviews...</p>';
    }

    state = {
      reviews: [],
      renderedKeys: existingPageReviewIdentity.keys,
      renderedFingerprints: existingPageReviewIdentity.fingerprints,
      nextCursor: null,
      featuredOffset: 0,
      featuredReviews: getScopedFeaturedReviews(config),
      productReviewsExhausted: false,
      hasNext: false,
      loading: false,
      iso: null,
      preRenderedCount: existingContainerReviewCount
    };

    root._grtReviewState = state;
    attachSectionEvents(root, config, state);

    await waitForIsotope();

    try {
      if (!existingContainerReviewCount) {
        container.innerHTML = '';
      }

      gridSizer = container.querySelector('.grid-sizer');
      if (!gridSizer) {
        gridSizer = document.createElement('div');
        gridSizer.className = 'grid-sizer';
        container.insertBefore(gridSizer, container.firstChild);
      }

      state.iso = mountIsotope(container);
      bindRelayout(state.iso, container);
      requestLayout(state.iso);

      totalVisibleReviews = state.preRenderedCount + state.reviews.length;
      missingCount = Math.max(0, config.pageSize - totalVisibleReviews);
      result = { reviews: [], hasNext: hasBucketReviewIds(config) || state.featuredOffset < state.featuredReviews.length };

      if (missingCount > 0) {
        result = await getNextBatch(config, state, missingCount);
      }

      if (result.reviews.length) {
        result.reviews.forEach(function (review) {
          state.renderedKeys.add(getReviewKey(review));
          state.renderedFingerprints.add(getReviewFingerprint(review));
        });
        appendReviews(container, config, state, result.reviews);
      }

      if (!(state.preRenderedCount + state.reviews.length)) {
        renderNoReviewState(container, config);
        state.hasNext = false;
        updateLoadMore(config, state);
        return;
      }

      state.hasNext = result.hasNext;
      updateLoadMore(config, state);
      bindLoadMore(container, root, config, state);
    } catch (error) {
      console.error('Failed to initialize review section ' + config.sectionId, error);
      container.innerHTML = '<p>Failed to load reviews.</p>';
      state.hasNext = false;
      updateLoadMore(config, state);
    }
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-grt-reviews]');
    var seenRootKeys = new Set();

    Array.prototype.forEach.call(roots, function (root) {
      var config;
      var rootKey;
      var modalOpener;

      if (root.dataset.grtReviewsReady === 'true') return;

      config = parseConfig(root);
      if (!config) return;

      rootKey = getReviewRootKey(config);
      if (rootKey && seenRootKeys.has(rootKey)) {
        root.style.display = 'none';
        modalOpener = document.getElementById('open-review-modal-' + config.sectionId);
        if (modalOpener) modalOpener.style.display = 'none';
        root.dataset.grtReviewsReady = 'true';
        return;
      }

      if (rootKey) seenRootKeys.add(rootKey);
      root.dataset.grtReviewsReady = 'true';
      initSection(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function () {
    initAll();
  });
})();
